import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { CountdownPanel } from './CountdownPanel';
import { SectionHeading } from './SectionHeading';
import { checkoutUrl, ctaBullets, product, valueStack } from '../data/content';
interface PricingProps {
  showUrgency?: boolean;
}
export function Pricing({
  showUrgency = true
}: PricingProps) {
  return <section id="precio" className="w-full bg-cream py-16 md:py-24" data-id="element-155" data-mp="1vts6baj81wu2">
      <div className="mx-auto w-full max-w-content px-5 md:px-8" data-id="element-156" data-mp="1vw4l5etonr2w">
        <SectionHeading eyebrow="Oferta de lanzamiento" title={<>
              Todo el megapack por <span className="italic text-gold-700" data-id="element-158" data-mp="25q4u5rs35ggw">$9.990 ARS</span>
            </>} intro={<p data-id="element-159" data-mp="20vhdgf3bpqcv">Una sola compra. Sin suscripción mensual ni pagos recurrentes.</p>} data-id="element-157" data-mp="1rtrn7cl6gxgo" />

        <div className="mx-auto mt-14 max-w-2xl rounded-2xl border-2 border-plum-700 bg-white shadow-lift" data-id="element-160" data-mp="3c8a5lr010gtg">
          <div className="flex justify-center" data-id="element-161" data-mp="3vzp6pldb6gal">
            <p className="-mt-4 rounded-full bg-plum-700 px-5 py-1.5 text-[0.65rem] font-bold uppercase tracking-[0.16em] text-white" data-id="element-162" data-mp="3vyx9y77z6ciq">
              El Puente del Adiós completo
            </p>
          </div>

          <div className="px-7 pb-10 pt-8 md:px-12" data-id="element-163" data-mp="9t0cngxj9zjm">
            <ul className="divide-y divide-plum-100" data-id="element-164" data-mp="erv57alaz2gx">
              {valueStack.map(line => <li key={line.label} className="flex items-baseline justify-between gap-4 py-3.5" data-id="element-165" data-mp="3d9h5x9x301xk">
                  <span className="text-[0.95rem] text-ink" data-id="element-166" data-mp="3i7iqy0e2ibbo">{line.label}</span>
                  <span className={`shrink-0 text-sm font-bold ${line.free ? 'text-teal-600' : 'text-plum-700'}`} data-id="element-167" data-mp="3n754yc1pzvlj">
                    {line.value}
                  </span>
                </li>)}
            </ul>

            <div className="flex items-baseline justify-between gap-4 border-t-2 border-plum-200 py-5" data-id="element-168" data-mp="2zhat9xt50d2v">
              <span className="font-display text-lg font-bold uppercase tracking-tight text-ink" data-id="element-169" data-mp="2rgcunrx1s7to">
                Valor regular:
              </span>
              <span className="shrink-0 text-lg font-bold text-muted line-through" data-id="element-170" data-mp="2mhi4g4wr3gzj">
                {product.listPrice}
              </span>
            </div>

            <div className="border-t border-plum-100 pt-8 text-center" data-id="element-171" data-mp="2w7bfn4szdu39">
              <p className="text-[0.7rem] font-bold uppercase tracking-[0.2em] text-gold-700" data-id="element-172" data-mp="28i0idxauahtv">
                Hoy
              </p>
              <p className="mt-2 font-display text-[3.4rem] font-extrabold leading-none tracking-tight text-plum-700 md:text-[4.2rem]" data-id="element-173" data-mp="23jz3zpocz6oq">
                {product.price}
              </p>
              <p className="mt-3 font-semibold text-ink" data-id="element-174" data-mp="2dgk6a38zu3ov">Pago único</p>
            </div>

            <div className="mt-9" data-id="element-175" data-mp="3tv3gc8r8zdfl">
              <CtaButton size="xl" variant="plum" href={checkoutUrl} className="w-full" data-id="element-176" data-mp="3tu0krnizcmtc">
                {product.cta}
              </CtaButton>
            </div>

            <ul className="mt-7 flex flex-wrap items-center justify-center gap-x-6 gap-y-2.5 text-sm text-ink" data-id="element-177" data-mp="9udk3n4ynj8">
              {ctaBullets.map(bullet => <li key={bullet} className="inline-flex items-center gap-2" data-id="element-178" data-mp="57dqn083ku9l">
                  <CheckIcon className="h-4 w-4 shrink-0 text-teal-500" aria-hidden="true" data-id="element-179" data-mp="3ngeirhnrihz6" />
                  {bullet}
                </li>)}
            </ul>
          </div>
        </div>

        {showUrgency && <div className="mx-auto mt-8 max-w-2xl" data-id="element-180" data-mp="j2y7lq49n2ed">
            <CountdownPanel data-id="element-181" data-mp="nywrp1ik9y8z" />
          </div>}
      </div>
    </section>;
}